import type { RefObject } from 'react';

import { useCallback } from 'react';

import type { EditorJsData } from '#pages/document/editorjs-types';

import { normalizeDocumentLinksInEditorJsData } from '../editor-document-links';

export function useCommitEditorOutput({
  latestValueRef,
  documentPathRegex,
}: {
  latestValueRef: RefObject<EditorJsData | null>;
  documentPathRegex: string;
}): (data: EditorJsData) => void {
  return useCallback(
    (data: EditorJsData) => {
      const origin =
        typeof window !== 'undefined' ? window.location.origin : '';
      latestValueRef.current =
        origin.length > 0
          ? normalizeDocumentLinksInEditorJsData(
              data,
              documentPathRegex,
              origin,
            )
          : data;
    },
    [documentPathRegex],
  );
}
